import React, { FC } from 'react';
import s from './AllSpecialists.module.scss';
import { ReactComponent as ArrowGoBackBlack } from 'images/new-icons/arrow-go-back.svg';
import { ReactComponent as ArrowGoBackWhite } from 'images/new-icons/arrow-left-white.svg';

type Props = {
  onClose: () => void;
  text: string;
  edit?: boolean;
  hasAvatar?: boolean;
};
const AllSpecialistsHeader: FC<Props> = ({ onClose, text, edit, hasAvatar }) => {
  return (
    <div className={s.all_specialists_header}>
      {hasAvatar ? <ArrowGoBackWhite onClick={onClose} /> : <ArrowGoBackBlack onClick={onClose} />}
      {!edit && <div className={s.all_specialists_header_title}>{text}</div>}
      {edit && <div className={s.all_specialists_header_title_edit}>{text}</div>}
    </div>
  );
};

export default AllSpecialistsHeader;
